let rapperImageLoader = (pic) => {
    return `https://bin.complex.com/websites/rap-brackets/img/rappers/${pic}.jpg`;
}


export default rapperImageLoader;